export default __webpack_public_path__ + "static/media/lighting_plant.e5263fdd.jpg";